// extracted by mini-css-extract-plugin
export default {"flag":"language_flag__1Q6X-"};